const talent_info = {
	key: 'talent_info',
	label: '达人信息',
	type: () => import('./components/talentInfo'),
	minWidth: '250',
};
const apply_num = {
	key: 'apply_num',
	label: '申样次数',
	type: 'rdText',
	minWidth: '80',
};
const send_num = {
	key: 'send_num',
	label: '寄样次数',
	type: 'rdText',
	minWidth: '80',
};
const price_sum = {
	key: 'price_sum',
	label: '样品成本',
	type: 'rdText',
	minWidth: '80',
};
const send_ratio = {
	key: 'send_ratio',
	label: '寄样率',
	type: 'rdText',
	minWidth: '80',
};
const play_num = {
	key: 'play_num',
	label: '开播次数',
	type: 'rdText',
	minWidth: '80',
};
const play_ratio = {
	key: 'play_ratio',
	label: '开播率',
	type: 'rdText',
	minWidth: '80',
};
const remark = {
	key: 'remark',
	label: '备注',
	type: 'rdText',
	minWidth: '180',
};
export const columns = [talent_info, apply_num, send_num, price_sum, send_ratio, play_num, play_ratio, remark];
